<template>
    <div id="modelFactory">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">模型工厂</div>
                    <div class="contentVal">
                        <span>利用机器学习技术对数据建立数学模型</span>
                        <span>帮助企业获取有价值的信息，助力企业高效发展业务</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
            </div>
        </div>
        <!--内容区-->
        <div class="modelFactoryConWrap">
            <!--例子-->
            <div class="exampleBox">
                <div class="left">
                    <div class="leftList" v-for="(item,index) in leftData" :key="index">
                        <div class="name">
                            {{item.name}} <span>{{item.work}}</span>
                        </div>
                        <div class="wordWrap" v-html="item.val"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="rightTitle">模型工厂的生产力可以驱动所有行业</div>
                    <div class="rightList" v-for="(item,index) in rightData" :key="index"
                         @click="chooseExampleEvent(index)">
                        <span></span>
                        <p v-html="item.val"></p>
                    </div>
                </div>
            </div>
            <!--产品设计-->
            <div class="productWrap">
                <div class="headline">产品设计</div>
                <div class="productBox">
                    <div class="listBox" :class="proIndex===1 ? 'active' : '' " @mouseover="proEvent(1)">
                        <div class="proTitle">
                            <img src="../../assets/01.png" v-show="proIndex!==1"/>
                            <img src="../../assets/01焦点.png" v-show="proIndex===1"/>
                            <span>多维度精细化地<br/>分析企业的样本参数</span>
                        </div>
                        <div class="proEnTitle">ANALYZE SAMPLE DATA IN MULTI-DIMENSIONAL DETAILS</div>
                        <div class="proVal" v-show="proIndex===1">
                            对企业有效、适量的样本参数进行结构化分析，剖析问题并搭建对企业起优化作用的模型框架，用于解决问题，快速响应业务需求并降低企业成本，让企业以最低成本产出最大效益
                        </div>
                    </div>
                    <div class="listBox" :class="proIndex===2 ? 'active' : '' " @mouseover="proEvent(2)">
                        <div class="proTitle">
                            <img src="../../assets/02.png" v-show="proIndex!==2"/>
                            <img src="../../assets/02焦点.png" v-show="proIndex===2"/>
                            <span>利用神经网络<br/>计算技术进行机器学习</span>
                        </div>
                        <div class="proEnTitle">MACHINE LEARNING IN THE FORM OF NEURAL NETWORKS</div>
                        <div class="proVal" v-show="proIndex===2">
                            以企业样本参数为基础，通过多方合作数据源，利用“神经网络计算+联邦学习”进行自动聚类+权重分析还原出目标的真实概况，建⽴目标画像分析，设定目标各维度评级并输出该样本的数学模型
                        </div>
                    </div>
                    <div class="listBox" :class="proIndex===3 ? 'active' : '' " @mouseover="proEvent(3)">
                        <div class="proTitle">
                            <img src="../../assets/03.png" v-show="proIndex!==3"/>
                            <img src="../../assets/03焦点.png" v-show="proIndex===3"/>
                            <span>经多次商业参数验证后<br/>输出最优数学模型</span>
                        </div>
                        <div class="proEnTitle">OUTPUT OPTIMAL MODEL AFTER DATA VERIFICATION</div>
                        <div class="proVal" v-show="proIndex===3">
                            对多次训练后的模型结合商业结果参数分析，得到最优的模型解决方案后向企业提供样本统计、模型分析、特征分析、分值分布等丰富的模型报告内容
                        </div>
                    </div>
                </div>
            </div>
            <!--应用价值-->
            <div class="applicationValue">
                <div class="headline" style="margin-bottom: 50px;">应用价值</div>
                <div class="applicationValueBox">
                    <div class="applicationValueList">
                        <img src="../../assets/img/modelFactory/营销服务.png"/>
                        <div class="listTitle">销售服务</div>
                        <div class="listVal">
                            通过智能技术建模找出共性参数，赋能营销服务，帮助企业筛选高价值用户、推荐最优产品、把控最佳销售时机、策划营销方案，助企业对销售线索进行甄别与拓展，塑造对销售线索的立体认知；优化企业营销策略，用更少的资源赢得更多客户
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/modelFactory/金融风控.png"/>
                        <div class="listTitle">金融风控</div>
                        <div class="listVal">
                            建立模型帮助金融企业针对客户群体进行特征分析，帮助企业有效识别潜在风险（如在信用卡、贷款、在线支付等业务场景中的违约、欺诈风险），提高风险识别能力，减少企业损失；识别高价值客户，提升企业的效益额
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/modelFactory/企业优化.png"/>
                        <div class="listTitle">企业优化</div>
                        <div class="listVal">
                            建立模型帮助企业找出各种特征参数，然后进行分析和评级，合理配置资源优化结构，提升效率
                        </div>
                    </div>
                </div>
            </div>
            <!--案例-->
            <div class="caseWrap">
                <div class="headline">案例</div>
                <div class="caseBox">
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某百货公司损失销售额的预测.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某百货公司损失销售额的预测</div>
                            <div class="rightValText">
                                某百货公司利用数据模型项科学、合理地预测损失的销售额。案例中，百货公司选择趋势预测模型和回归模型，对损失的销售额进行了合理的预测，保证最终能被保险公司所接受，为公司进行索赔提供有利的支持，减少公司损失
                            </div>
                        </div>
                    </div>
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/特斯拉实力超群的神经网络.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">特斯拉实力超群的神经网络</div>
                            <div class="rightValText">
                                特斯拉有一个方面一直领先着竞争对手好几英里。这就是其利用数据来构建的世界上最复杂、最尖端的神经网络,
                                特斯拉利用数据、人工智能和数学建模语言来构建了一个神经网络--一个由传感器、数据、通信、处理器、外围硬件和软件组成的系统，像人类一样共同处理信息、适应和学习
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--相关产品-->
            <div class="relevantProduct">
                <div class="headline">相关产品</div>
                <!--产品列表-->
                <div class="relevantProductListWrap">
                    <div class="relevantProductList" @click="toPage('/smartLabel')" style="margin-right: 114px;">
                        <img src="../../assets/img/bigIcon/智能标签.png"/>
                        <span>智能标签</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/factorServices')" style="margin-right: 98px;">
                        <img src="../../assets/img/bigIcon/因子服务.png"/>
                        <span>因子服务</span>
                    </div>
                    <!--@click="toPage('/RiskListFiltering')"-->
                    <div class="relevantProductList" style="opacity: 0.3;cursor: not-allowed">
                        <img src="../../assets/img/bigIcon/风险名单过滤.png"/>
                        <span>风险名单过滤</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "modelFactory",
        data() {
            return {
                proIndex: 1,
                /*数据*/
                rightData: [
                    {val: "传统行业数据建模助力产业升级"},
                    {val: "孤岛数据生态进化为“广维度数据建模”驱动全行业发展"},
                ],
                allData: {
                    0: [
                        {
                            name: "赵小姐", work: "某农产品公司销售主管",
                            val: "当前，伴随着新一轮的信息技术革命和商业模式创新，实体传统经济插上数字" +
                                "化羽翼，一场以数字化为形式、以技术进步为手段、以经济转型升级为目标的变革" +
                                "已经全面展开，大数据技术驱动传统行业升级迫不及待<br/>" +
                                "大数据建模能很好地建立创新驱动发展的落脚点。让大数据更好地落地，实现地方" +
                                "产业的转型升级，在具体的地方优势产业中研究落地大数据应用新思维与新路径"
                        },
                        {
                            name: "胡先生", work: "某企业总经理",
                            val: "信息化发展，大量信息系统在企业中广泛应用，技术与企业经营生产紧密结合" +
                                "，数据采集过程更加自动化，企业积累了大量的数据，各个运营环节也被记录下来，" +
                                "这些数据隐藏着大量的有价值的规律和信息，是企业的重要资产<br/>" +
                                "大数据分析建模是数据到信息转变的重要支撑，也是凸显数据价值实现的重要环节，" +
                                "企业应加强业务需求调研与业务架构优化，结合业务发展目标"
                        },
                        {
                            name: "杨先生", work: "某传统企业技术人员",
                            val: "我国正处于经济发展新旧动能接续转换的关键时期，各行各业都应高度重视大数" +
                                "据在促进创新驱动、优化资源配置、实现智能经营等方面发挥的重要作用，需要争分" +
                                "夺秒完成数字化转型<br/>" +
                                "融入大数据、依托各产业的大数据资源进行数学建模，奠定决策基础，实现大数据与" +
                                "传统产业的深度融合，是传统企业当前面临的重大课题"
                        }
                    ],
                    1: [
                        {
                            name: "王先生", work: "某企业高管",
                            val: "企业过往都有数据护城河，信息不互通，导致发展速度及运营模式、商业模式" +
                                "滞留不前，缺乏创新性，不仅仅如此，孤岛数据本身就存在维度窄，信息少的局限" +
                                "性，存在的数据并没有最大化地产出最大的商业能量<br/>" +
                                "利用大数据建模技术，相关的合作方式把孤岛数据打通，把强相关的数据聚合起来，" +
                                "更好地驱动全行业发展"
                        },
                        {
                            name: "蔡女士", work: "某创业公司投资者",
                            val: "行业的痛点在于数据岛屿群间相互割裂，彼此孤立，甚至在岛屿群内部、或某" +
                                "一特定岛屿（企业）中，而呈各自分散的“岛中岛”状态。但是看起来完全没有关系" +
                                "的企业，都在默默收集和存储着自己的业务数据，局限了全行业的发展速度<br/>" +
                                "把数据维度扩大是未来的发展趋势，数学模型技术才会最大限度地把多维度数据建" +
                                "立出一个更高价值的模型，让行业更快速又健康地发展"
                        },
                        {
                            name: "萧先生", work: "某行业资深研究员",
                            val: "某公司与地方政府有项目合作，收集整理3个城市的店铺信息，用于分析店铺" +
                                "的特征信息，除满足项目需求，希望能找到数据复用性，从这些数据中再挖掘出" +
                                "新的商机，于是面临同样的问题：“这些数据还能用来做什么？”<br/>" +
                                "明显的数据孤岛问题局限了企业的业务拓展，假设融合多维度数据，用数学建模的" +
                                "方式提取更多的特征，让企业有更广阔的发展可能性"
                        }
                    ],
                },
                leftData: [],
                showAlertFlag: false
            }
        },
        created() {
            /*初始化案例*/
            this.leftData = this.allData[0];
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            proEvent(index) {
                this.proIndex = index;
            },
            toPage(page) {
                this.$router.push({path: page});
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("exampleBox")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("productWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("applicationValue")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("caseWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            },
            /*切换案例数据*/
            chooseExampleEvent(index) {
                this.leftData = this.allData[index];
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #modelFactory {
        .bannerWrap {
            background: url("../../assets/img/modelFactory/模型工厂banner.png") no-repeat center;
            background-color: #00051D;
        }

        .modelFactoryConWrap {
            background: url("../../assets/bgImg.png") no-repeat center;
            background-size: cover;
            padding-top: 80px;

            .exampleBox {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 1200px;
                margin: 0 auto 120px;
                padding: 0 0 0 76px;

                .left {
                    width: 458px;
                    padding-top: 44px;
                    margin-right: 128px;

                    .leftList {
                        padding: 20px 20px 20px 31px;
                        margin-bottom: 16px;
                        border-radius: 4px;
                        border: 1px solid #EAEEF4;
                        background: #fff;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .name {
                            margin-bottom: 4px;
                            font-size: 14px;
                            color: #1B2D35;

                            span {
                                margin-left: 10px;
                                font-size: 12px;
                                color: #40B0FF;
                            }
                        }

                        .wordWrap {
                            opacity: 0.6;
                            margin-bottom: 4px;
                            font-size: 12px;
                            color: #152346;
                            text-align: justify;
                            line-height: 24px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .right {
                    .rightTitle {
                        margin-bottom: 60px;
                        font-size: 30px;
                        color: #152346;
                    }

                    .rightList {
                        display: flex;
                        align-items: center;
                        margin-bottom: 40px;
                        line-height: 22px;
                        cursor: pointer;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        span {
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            margin-right: 22px;
                            background: #22A5FF;
                        }

                        p {
                            font-size: 16px;
                            color: #152346;
                        }
                    }
                }
            }

            .productWrap {
                .productBox {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 1200px;
                    height: 330px;
                    margin: 70px auto 112px;

                    .listBox {
                        height: 100%;
                        padding: 69px 0 0 40px;
                        cursor: pointer;
                        background: #F6F9FF;
                        flex: 1;
                        transition: all .4s;

                        .proTitle {
                            position: relative;
                            margin-bottom: 32px;
                            font-size: 26px;
                            color: #152346;
                            line-height: 40px;
                            font-weight: bold;

                            span {
                                display: inline-block;
                                position: relative;
                                z-index: 100;
                            }

                            img {
                                position: absolute;
                                left: 0;
                                bottom: 20px;
                            }
                        }

                        .proEnTitle {
                            opacity: 0.3;
                            font-size: 12px;
                            color: #152346;
                            letter-spacing: 0.17px;
                            line-height: 22px;
                        }
                    }

                    .active {
                        min-width: 540px;
                        background: url("../../assets/produceBlueBg.png") no-repeat center;
                        background-size: cover;

                        .proTitle {
                            margin-bottom: 0 !important;
                            font-size: 32px !important;
                            color: #FFFFFF;
                            line-height: 40px !important;
                        }

                        .proEnTitle {
                            margin-bottom: 20px;
                            font-size: 14px !important;
                            color: #FFFFFF !important;
                            letter-spacing: 0.4px !important;
                            line-height: 24px !important;
                        }

                        .proVal {
                            padding-right: 40px;
                            font-size: 12px;
                            color: #FDFDFD;
                            line-height: 22px;
                        }
                    }
                }
            }

            .applicationValue {
                .applicationValueBox {
                    display: flex;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto 130px;

                    .applicationValueList {
                        width: 300px;
                        text-align: center;

                        img {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 24px;
                        }

                        .listTitle {
                            margin-bottom: 12px;
                            font-size: 20px;
                            color: #152346;
                        }

                        .listVal {
                            opacity: 0.7;
                            font-size: 12px;
                            color: #152346;
                            line-height: 22px;
                            text-align: justify;
                        }
                    }
                }
            }

            .caseWrap {
                .caseBox {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto;

                    .caseList {
                        display: flex;
                        align-items: flex-start;

                        .leftImg {
                            width: 192px;
                            height: 186px;
                            margin-right: 16px;
                        }

                        .rightVal {
                            padding-top: 16px;

                            .rightValTitle {
                                opacity: 0.6;
                                margin-bottom: 10px;
                                font-size: 20px;
                                color: #152346;
                            }

                            .rightValText {
                                width: 339px;
                                opacity: 0.4;
                                font-size: 12px;
                                color: #152346;
                                line-height: 24px;
                            }
                        }
                    }
                }
            }

            .relevantProduct {
                width: 436px;
            }
        }
    }
</style>
